module.exports = __webpack_public_path__ + "static/media/housetype-blue.24327e05.svg";